module.exports = __webpack_public_path__ + "img/animation5.4a50e5b0.png";